import React from 'react';

const NoReportData = () => (
  <div className="report-results d-flex justify-content-center align-items-center">
    <h1>No Data</h1>
  </div>
);

export default NoReportData;
